import React from 'react';
import { inject, observer } from 'mobx-react';
import { ArticleProps as UIArticleProps } from '@shopee/chatbot-ui/lib/components/Article';

import { getChildInject } from '@/utils/instantLoaded/tools';
import { ChatbotUIBasicProps } from '@/types/common';
import Article from '../ChatbotUI/Article';

export type ArticleProps = UIArticleProps & {
  article_number: string;
  kb_intent_id: string;
  kb_bot_id: string;
  kb_edition: string;
  kb_answer_id: string;
  agentStore?: any;
  listPos?: number;
} & ChatbotUIBasicProps;

const SingleArticle = (props: ArticleProps) => {

  return (
    <Article {...props} isSingleArticle={true}/>
  );
};

export default inject(getChildInject('agentStore'))(observer(SingleArticle));
